import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { DiscountInOutflowModalProps } from './DiscountInOutflowModal';

export const renderDiscountInOutflowModal = (data: DiscountInOutflowModalProps) =>
    openPopupHelper({ popupName: popupNames.DISCOUNT_IN_OUTFLOW_MODAL, data });

export const closeDiscountInOutflowModal = () => closePopupHelper(popupNames.DISCOUNT_IN_OUTFLOW_MODAL);
